import { render } from "./STERiJECT.vue?vue&type=template&id=9d62fea0&scoped=true"
import script from "./STERiJECT.vue?vue&type=script&lang=js"
export * from "./STERiJECT.vue?vue&type=script&lang=js"

import "./STERiJECT.vue?vue&type=style&index=0&id=9d62fea0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d62fea0"]])

export default __exports__